import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';
import { NameSchema } from '@/validators/shared/utility/name.schema';
import { GroupType } from '@/types/api/group';

export const RegisterGroupInputSchema = z.object({
  groupName: NameSchema,
  organizationName: NameSchema,
  groupType: z.nativeEnum(GroupType),
  includeMemberRole: z.boolean(),
});

export type RegisterGroupInput = z.infer<typeof RegisterGroupInputSchema>;

export type RegisterGroupResult = {
  orgId: string;
};

export const registerGroup = async ({ data }: { data: RegisterGroupInput }): Promise<RegisterGroupResult> => {
  return (await api.post(`/groups/register`, data)).data;
};

type UseRegisterGroupOptions = {
  mutationConfig?: MutationConfig<typeof registerGroup>;
};

export const useRegisterGroup = ({ mutationConfig }: UseRegisterGroupOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      // queryClient.refetchQueries({});
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: registerGroup,
  });
};
